import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import ZGrid from '../components/ZGrid';
import { withStyles } from '@material-ui/core/styles';
import Card from '@mui/material/Card';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ZButton from '../components/ZButton';
import { withRouter } from "react-router-dom";
import Stepper from '../components/Stepper';
import QrToken from '../containers/QrToken';
import Transaction from '../containers/Transaction';
import { getClientIp } from '../utils/common_function/common_function';
import Networking from '../utils/network/apiaccess';
import url from '../utils/api/ApiValues';
import label from '../utils/constants/label';
import TextField from '@mui/material/TextField';
import { alphaNumericOnly, numbersOnly } from '../utils/common_function/common_function';
import Color from '../utils/constants/Colors';
import { connect } from "react-redux";
import { accNoAdd } from '../redux/action/storetoken';
import { bindActionCreators } from "redux";
import Alert from '../components/alert/alert';
// import Account from '../utils/constants/AccountNumber.json';

let autoflag = true;
const drawerWidth = 240;

function FundTransfer(props) {
  // let { amount } = useParams();
  const [fromAcc, setFromAcc] = React.useState('');
  const [toAcc, setToAcc] = React.useState('');

  const [fromAccError, setFromAccError] = React.useState('');
  const [toAccError, setToAccError] = React.useState('');

  const onChangeFromAcc = (event) => {
    console.log("event", event)
    setFromAcc(event.target.value);
    setFromAccError("")
  };

  const onChangeToAcc = (event) => {
    setToAcc(event.target.value);
    setToAccError("");
    setBeneficiaryName(beneficiaryList.filter(item => (item.accountNo == event.target.value))[0].name)
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  const [alert, setAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState('');
  const [severity, setSeverity] = React.useState('success');

  const [submitLoader, setSubmitLoader] = React.useState(false);

  const [valuesFromVk2FA, setValuesFromVk2FA] = React.useState("");
  const [miriAccNo, setMiriAccNo] = React.useState("");

  const [beneficiaryList, setBeneficiaryList] = React.useState([]);
  const [fromAccountList, setFromAccountList] = React.useState([]);

  const [beneficiaryName, setBeneficiaryName] = React.useState("");
  const [beneficiaryNameError, setBeneficiaryNameError] = React.useState("");

  const [amount, setAmount] = React.useState("");
  const [amountError, setAmountError] = React.useState("");

  const [remark, setRemark] = React.useState("");

  const [mobile, setMobile] = React.useState("");
  const [mobileError, setMobileError] = React.useState("");
  const [allData, setAllData] = React.useState({});
  const [status, setStatus] = React.useState(label.flag.failure);

  useEffect(() => {
    if (props.location.search != "" && autoflag) {
      let value = props.location.search.slice(1)
      setMiriAccNo(value);
      //Storing token to redux
      props.accNoAdd(value);
      autoflag = false;
    } else {
      //Set stored values from redux
      setMiriAccNo(props.accNo);
    }


    fetch("./AccountNumber.json").then(
      function (res) {
        return res.json()
      }).then(function (data) {
        setBeneficiaryList(data.accountDetails)
        setFromAccountList(data.fromAccount)
      }).catch(
        function (err) {
          console.log(err, ' error')

        }
      )

  }, [props.location]);

  const handleAlert = () => {
    setAlert(false);
  };

  const classes = props.classes

  const handleClick = (value) => {
    setActiveStep(1)
    setCompleted({ ...completed, 0: true });
  }

  const tryAgain = () => {
    setActiveStep(0)
    setCompleted({});
    setBeneficiaryName("");
    setMobile("");
    setRemark("");
    setAmount("");
    setToAcc("");
    setFromAcc("");
  }

  const stepTwoSubmit = async (token, MiriAccNo, status) => {
    setSubmitLoader(true);
    if (status == label.flag.success) {
      setStatus(label.flag.success)
      let ip = ""

      getClientIp().then((res) => {
        ip = res
      })
      // const res = await axios.get("https://geolocation-db.com/json/");

      var data = new FormData();
      data.append("altKey", MiriAccNo); //Miri Account No
      data.append("token", token);
      data.append("hint", '');
      data.append("ipAddress", localStorage.getItem("IPAddress"));
      data.append("browserName", '');
      data.append("version", '1.0');
      Networking.PostApi(url.validateMiriToken, data).then((resp) => {
        if (resp.status == label.flag.success) {
          setStatus(label.flag.success)
          setSubmitLoader(false);
          setActiveStep(2);
          setCompleted({ ...completed, 1: true });
        } else if (resp.status == label.flag.failure) {
          setStatus(label.flag.failure)
          setSubmitLoader(false);
          setAlertMessage(resp.message);
          setSeverity('warning');
          setAlert(true);
          // setActiveStep(2);
          // setCompleted({ ...completed, 1: true });
        }
      })
    } else {
      setStatus(label.flag.failure);
      // setActiveStep(2);
      // setCompleted({ ...completed, 1: true });
    }
  }

  const onChangeBeneficiaryName = (e) => {
    if (alphaNumericOnly(e.target.value) && e.target.value.length < 31) {
      setBeneficiaryName(e.target.value);
      setBeneficiaryNameError("");
    } else {
      e.preventDefault();
    }
  }

  const onChangeAmount = (e) => {
    if (numbersOnly(e.target.value) && e.target.value.length < 9) {
      setAmount(e.target.value);
      setAmountError("");
    } else {
      e.preventDefault();
    }
  }

  const onChangeMobile = (e) => {
    if (numbersOnly(e.target.value) && e.target.value.length < 11) {
      setMobile(e.target.value);
      setMobileError("");
    } else {
      e.preventDefault();
    }
  };

  const onChangeRemark = (e) => {
    if (e.target.value.length < 31) {
      setRemark(e.target.value);
    } else {
      e.preventDefault();
    }
  };

  const fundTransferSubmit = () => {



    let fromAccValid = false;
    let beneficiaryNameValid = false;
    let toAccValid = false;
    let amountValid = false;
    let mobileValid = false;

    if (fromAcc == '' || fromAcc == '- Select An Account -') {
      fromAccValid = false;
      setFromAccError(`${label.messages.kindlySelect} ${label.fundTransfer.fromaccount}`)
    } else {
      fromAccValid = true;
    }

    if (beneficiaryName == '') {
      beneficiaryNameValid = false;
      setBeneficiaryNameError(`${label.messages.kindlyProvide} ${label.fundTransfer.name}`)
    } else {
      beneficiaryNameValid = true;
    }

    if (toAcc == '' || toAcc == '- Select An Account -') {
      toAccValid = false;
      setToAccError(`${label.messages.kindlySelect} ${label.fundTransfer.accountNo}`)
    } else {
      toAccValid = true;
    }

    if (amount == '') {
      amountValid = false;
      setAmountError(`${label.messages.kindlyProvide} ${label.fundTransfer.amount}`)
    } else {
      amountValid = true;
    }

    if (mobile == '') {
      mobileValid = false;
      setMobileError(`${label.messages.kindlyProvide} ${label.fundTransfer.mobileNo}`)
    } else if (mobile.length != 10) {
      setMobileError(`${label.messages.kindlyProvide} ${label.messages.valid} ${label.fundTransfer.mobileNo}`)
    } else {
      mobileValid = true;
    }

    if (fromAccValid && beneficiaryNameValid && toAccValid && amountValid && mobileValid) {
      let data = {};
      data.fromAcc = fromAcc;
      data.beneficiaryName = beneficiaryName;
      data.toAcc = toAcc;
      data.amount = amount;
      data.mobile = mobile;
      data.remark = remark;
      setAllData(data);
      handleClick();
    }
  }

  return (
    <Box>
      <ZGrid item md={12}>
        {/* <Card className={classes.profileCard} elevation={0}>
          <div className={classes.stepper} style={{ padding: 20 }}>
            <Stepper activeStep={activeStep} completed={completed} />
          </div>
          {activeStep == 0 &&
            <Card className={classes.profileCard} style={{ marginTop: 10 }} elevation={0}>

              <CardContent> 
                <div className={classes.cardHeader}>HDFC</div>

                <ZGrid container spacing={2} className={classes.GridContainer}>
                  <ZGrid item xs={6} md={4}>
                    <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                      <ZTextBox autoFocus={true} label="Name" variant="standard" className={classes.miriID}>
                      </ZTextBox>
                    </FormControl>
                  </ZGrid>

                  <ZGrid item xs={6} md={4}>
                    <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                      <ZTextBox autoFocus={true} label="Account Number" variant="standard" className={classes.miriID}>
                      </ZTextBox>
                    </FormControl>
                  </ZGrid>
                  <ZGrid item xs={6} md={4}>
                    <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                      <ZTextBox autoFocus={true} label="IFSC Code" variant="standard" className={classes.miriID}>
                      </ZTextBox>
                    </FormControl>
                  </ZGrid>
                  <ZGrid item xs={6} md={4}>
                    <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                      <ZTextBox autoFocus={true} label="Amount" variant="standard" className={classes.miriID}>
                      </ZTextBox>
                    </FormControl>
                  </ZGrid>

                  <ZGrid item xs={6} md={4}>
                    <div className={classNames(classes.textField, classes.formControl)}>
                      <ZTextBox autoFocus={true} label="Mobile" variant="standard" className={classes.miriID}>
                      </ZTextBox>
                    </div>
                  </ZGrid>
                </ZGrid>

                <ZGrid container spacing={3} >
                  <ZGrid item xs={8} md={8}></ZGrid>
                  <ZGrid item xs={8} md={8}></ZGrid>
                  <ZGrid item xs={4} md={4} className={classes.actionButton}>
                    <div className={classes.dflex}>
                      <ZButton variant="contained"
                        color="primary" name="Next" onClick={() => { handleClick(0) }} className={classes.btnLogin} ></ZButton>
                      {/* <ZButton variant="outlined"
                  color="primary" name="Cancel" className={classes.btnLogin}></ZButton> */}
        {/* </div>
                  </ZGrid>
                </ZGrid>
              </CardContent>
            </Card>
          }
          {activeStep == 1 &&
            <QrToken submit={(token, MiriAccNo) => stepTwoSubmit(token, MiriAccNo)} back={() => { setActiveStep(0) }} MiriAccNo={miriAccNo}z values={valuesFromVk2FA} submitLoader={submitLoader} />
          }
          {activeStep == 2 &&
            <Transaction values={valuesFromVk2FA} />
          }
        </Card>*/}
        <Alert
          open={alert}
          message={alertMessage}
          onClose={handleAlert}
          severity={severity}
        ></Alert>

        <Card className={classes.profileCard} elevation={0}>
          <div className={classes.cardHeader} style={{ padding: "20px 20px 0px" }}>Funds Transfer</div>
          <div className={classes.stepper} style={{ padding: 12, background: "#f8f9fa", margin: "0px 20px" }}>
            <Stepper activeStep={activeStep} completed={completed} />
          </div>
          {activeStep == 0 &&
            <div className={classes.profileCard} elevation={0}>

              <div>
                <ZGrid container className={classes.GridContainer}>

                  <div className={classes.cardHeader} style={{ padding: "0px", marginBottom: 0 }}> </div>
                  <ZGrid item xs={12} style={{ minHeight: 67 }}>
                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                        From Account
                      </ZGrid>

                      <ZGrid item xs={4}>
                        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ width: "100%", margin: 0 }}>
                          <Select className={classes.select}
                            value={fromAcc}
                            onChange={(e) => onChangeFromAcc(e)}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            <MenuItem value="">- Select An Account -
                            </MenuItem>
                            {fromAccountList.map((i) => {
                              return <MenuItem value={i.accountNo}> {i.accountNo}</MenuItem>
                            })
                            }

                          </Select>
                        </FormControl>
                      </ZGrid>
                    </ZGrid>

                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", marginBottom: 3, }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                      </ZGrid>
                      <ZGrid item xs={4}>
                        {fromAccError == "" ? (
                          <span className={classes.errorStyle}>{" "}</span>
                        ) : (
                          <span className={classes.errorStyle}>{fromAccError}</span>
                        )}
                      </ZGrid>
                    </ZGrid>
                  </ZGrid>



                  <ZGrid item xs={12} style={{ minHeight: 67 }}>
                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                        Beneficiary Account Number
                      </ZGrid>

                      <ZGrid item xs={4}>
                        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ width: "100%", margin: 0 }}>
                          <Select className={classes.select}
                            value={toAcc}
                            onChange={(e) => onChangeToAcc(e)}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            <MenuItem value="">- Select An Account -
                            </MenuItem>
                            {beneficiaryList.map((i) => {
                              return <MenuItem value={i.accountNo}>{`${i.name} - ${i.accountNo}`}</MenuItem>
                            })
                            }
                          </Select>
                        </FormControl>
                      </ZGrid>
                    </ZGrid>

                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", marginBottom: 3, }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                      </ZGrid>
                      <ZGrid item xs={4}>
                        {toAccError == "" ? (
                          <span className={classes.errorStyle}>{" "}</span>
                        ) : (
                          <span className={classes.errorStyle}>{toAccError}</span>
                        )}
                      </ZGrid>
                    </ZGrid>
                  </ZGrid>


                  {/* <ZGrid item xs={12} style={{ minHeight: 67 }}>
                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                        Beneficiary Name
                      </ZGrid>

                      <ZGrid item xs={4}>
                        <TextField className={classes.textField} style={{ width: "100%" }}
                          id="outlined-password-input"
                          label=""
                          disabled
                          value={beneficiaryName}
                          autoComplete="off"
                          onChange={(e) => { onChangeBeneficiaryName(e) }}
                        />
                      </ZGrid>
                    </ZGrid>

                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", marginBottom: 3, }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                      </ZGrid>
                      <ZGrid item xs={4}>
                        {beneficiaryNameError == "" ? (
                          <span className={classes.errorStyle}>{" "}</span>
                        ) : (
                          <span className={classes.errorStyle}>{beneficiaryNameError}</span>
                        )}
                      </ZGrid>
                    </ZGrid>
                  </ZGrid> */}



                  <ZGrid item xs={12} style={{ minHeight: 67 }}>
                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                        Amount (USD)
                      </ZGrid>

                      <ZGrid item xs={4}>
                        <TextField className={classes.textField} style={{ width: "100%" }}
                          value={amount}
                          id="outlined-password-input"
                          label=""
                          autoComplete="off"
                          onChange={(e) => { onChangeAmount(e) }}
                        />
                      </ZGrid>
                    </ZGrid>

                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", marginBottom: 3, }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                      </ZGrid>
                      <ZGrid item xs={4}>
                        {amountError == "" ? (
                          <span className={classes.errorStyle}>{" "}</span>
                        ) : (
                          <span className={classes.errorStyle}>{amountError}</span>
                        )}
                      </ZGrid>
                    </ZGrid>
                  </ZGrid>

                  <ZGrid item xs={12} style={{ minHeight: 67 }}>
                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                        Mobile
                      </ZGrid>

                      <ZGrid item xs={4}>
                        <TextField className={classes.textField} style={{ width: "100%", }}
                          value={mobile}
                          id="outlined-password-input"
                          label=""
                          autoComplete="current-password"
                          onChange={(e) => { onChangeMobile(e) }}
                        />
                      </ZGrid>
                    </ZGrid>

                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", marginBottom: 3, }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                      </ZGrid>
                      <ZGrid item xs={4}>
                        {mobileError == "" ? (
                          <span className={classes.errorStyle}>{" "}</span>
                        ) : (
                          <span className={classes.errorStyle}>{mobileError}</span>
                        )}
                      </ZGrid>
                    </ZGrid>
                  </ZGrid>

                  <ZGrid item xs={12} style={{ minHeight: 67 }}>
                    <ZGrid container item xs={6} md={12} style={{ justifyContent: "center", }}>
                      <ZGrid item xs={4} style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                        Remarks
                      </ZGrid>

                      <ZGrid item xs={4}>
                        <TextField className={classes.textField} style={{ width: "100%", }}
                          id="outlined-password-input"
                          label=""
                          value={remark}
                          autoComplete="current-password"
                          onChange={(e) => { onChangeRemark(e) }}
                        />
                      </ZGrid>
                    </ZGrid>



                    <ZGrid container item xs={12} style={{ justifyContent: "center" }}>
                      <ZGrid item xs={4}></ZGrid>
                      <ZGrid item xs={4} md={4} className={classes.actionButton}>
                        {/* <div className={classes.dflex}> */}
                        <ZButton variant="contained"
                          color="primary" name="Next" onClick={() => { fundTransferSubmit() }} className={classes.btnLogin} ></ZButton>
                        {/* </div> */}
                      </ZGrid>
                    </ZGrid>
                  </ZGrid>



                  {/* <ZGrid item xs={6} md={4}>
                  <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                    <ZTextBox autoFocus={true} label="Account Number" variant="standard" className={classes.miriID}>
                    </ZTextBox>
                  </FormControl>
                </ZGrid>
                <ZGrid item xs={6} md={4}>
                  <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                    <ZTextBox autoFocus={true} label="IFSC Code" variant="standard" className={classes.miriID}>
                    </ZTextBox>
                  </FormControl>
                </ZGrid>
                <ZGrid item xs={6} md={4}>
                  <FormControl variant="standard" className={classNames(classes.textField, classes.formControl)}>
                    <ZTextBox autoFocus={true} label="Amount" variant="standard" className={classes.miriID}>
                    </ZTextBox>
                  </FormControl>
                </ZGrid>

                <ZGrid item xs={6} md={4}>
                  <div className={classNames(classes.textField, classes.formControl)}>
                    <ZTextBox autoFocus={true} label="Mobile" variant="standard" className={classes.miriID}>
                    </ZTextBox>
                  </div>
                </ZGrid> */}
                </ZGrid>

              </div>
            </div>
          }
          {activeStep == 1 &&
            <QrToken submitLoader={submitLoader} submit={(token, Vken2FACode, status) => stepTwoSubmit(token, Vken2FACode, status)} back={() => { setActiveStep(0) }} miriAccNo={miriAccNo} allData={allData} />
          }
          {activeStep == 2 &&
            <Transaction allData={allData} status={status} handleClickTryAgain={() => tryAgain()} />
          }
        </Card>
      </ZGrid>
    </Box >
  );
}

const styles = (theme) => ({

  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 100,
    // backgroundColor: "#fff",
    backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    // boxShadow:'none'
    boxShadow: '0px 0px 0px 0.5px rgb(0 0 0 / 9%)',
    backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    margin: "0px !important",
    '& .MuiToolbar-root': {
      padding: 0,
      minHeight: 90
    }
  },

  textField: {
    "& div > .MuiOutlinedInput-input": {
      padding: "6px 14px"
    }
  },

  stepper: {
    "& .MuiStepLabel-label": {
      fontFamily: 'Noto Sans',
      fontSize: "1rem",
      color: "#000"

    },

    "& .MuiStepper-root": {
      justifyContent: "center",
      overflow: "hidden"

    },

    "& .MuiStepConnector-root": {
      flex: "0.2 1 auto"
    },

    "& .MuiStepConnector-line": {
      borderColor: "#92278f",
      borderTopWidth: 2
    },

    "& .MuiStepLabel-iconContainer": {
      fontFamily: "Noto Sans",
      fontSize: 14,
      color: "#212529",
      "& .MuiStepIcon-root.Mui-active":
      {
        color: "#92278f",
        fontSize: "2rem",
        fontWeight: 600,
        "& .MuiStepIcon-text": {
          fontWeight: 600,
          fill: "#fff"
        }
      },
    },

    "& .MuiStepLabel-label.Mui-active": {
      color: "#92278f",
      fontWeight: 600,
    },

    "& .MuiStepIcon-root": {
      color: "#fff",
      fontSize: "1.75rem",
      "& .MuiStepIcon-text": {
        fontWeight: 600,
        fill: "#92278f"
      }
    },
  },

  dflex: {
    display: "flex",
    '& .MuiButton-root': {
      marginTop: "12px !important"
    }
  },

  select: {
    "& .MuiSelect-select": {
      padding: "9px 14px"
    }
  },

  featureHeader: {
    // backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",

    textTransform: "Capitalize",
    boxShadow: "none !important",
    backgroundSize: "150%",
    backgroundPositionX: "25%",
    padding: 20,
    marginTop: 20,
    borderRadius: "0.75rem !important",
    fontFamily: 'Josefin Sans',
    background: "#fff8ff !important",
    fontFamily: 'Josefin Sans',

    '& div': {
      padding: "8px 0px",
      lineHeight: "1.4rem",
      color: "#212529",
      fontFamily: 'Josefin Sans',
    }
  },
  GridContainer: {
    // minHeight: 90,
    border: "1px solid rgba(0, 0, 0, 0.12)",
    padding: 10,
    margin: "20px 20px 0",
    width: "auto",
    minHeight: 478
  },

  actionButton: {
    display: "flex", justifyContent: "flex-end", marginTop: 5,
    "& div > button.MuiButton-root ": {
      margin: "5px 0px 0px !important"
    }
  },



  payFromMenu: {
    color: "rgba(0, 0, 0, 0.87) !important",
    fontFamily: "Noto Sans  !important",
  },

  formControl: {
    width: "86%",
    margin: "4px !important",
    '& .MuiInputLabel-root': {
      color: "#9B9B9B",
      padding: 0, fontFamily: "Noto Sans ",
      lineHeight: 1,
    },

    '& .MuiFormControl-root': {
      width: "86%",
    },

    '& .MuiSelect-select': {
      fontFamily: "Noto Sans ",
    },

    '& .MuiFormHelperText-root': {
      color: "#f1416c"
    }
  },

  '& .MuiSelect-select': {
    fontFamily: "GT Walsheim Pro",
  },

  '& label.MuiInputLabel-root': {
    color: "#9B9B9B",
    padding: 0, fontFamily: "Noto Sans ",
    lineHeight: 1,
    '& + .MuiInput-root': {
      fontFamily: "Noto Sans ",
    }

  },

  '& input.MuiInputBase-input': {
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: "Noto Sans ",
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
      marginRight: 40,
    }
  },


  profileCard: {
    // boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%) !important",
    borderRadius: "0.75rem !important",
  },

  cardHeader: {
    fontWeight: "bold",
    textTransform: "uppercase",
    color: "#f7941d",
    fontSize: "1rem",
    marginBottom: 10,
    fontFamily: 'Josefin Sans',
    '& div.MuiInput-root:after': {
      borderBottom: "2px solid #303778"
    }
  },

  miriID: {
    width: "100%",
    margin: "0px 0px 20px 0px !important",

    '& label.MuiInputLabel-root.Mui-focused': {
      color: "#303778"
    },
    '& label.MuiInputLabel-root': {
      color: "#9B9B9B",
      padding: 0, fontFamily: "GT Walsheim Pro",
      lineHeight: 1,


      '& input.MuiInputBase-input': {
        color: "rgba(0, 0, 0, 0.87)",
        fontFamily: "GT Walsheim Pro",
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
          marginRight: 40,
        }
      },

      '& label.MuiInputLabel-root.Mui-focused': {
        color: "#303778"
      },

      '& div.MuiInput-root:after': {
        borderBottom: "2px solid #303778"
      }

    },
  },



  // account:{fontSize: "1.25rem", color: "#212529" },

  // balance:{ color: "#212529",paddingTop: 15, fontSize: "1.15rem",fontWeight:600},

  userWelcome: {
    display: "flex",
    alignItems: "center",
    marginLeft: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529"
  },

  cardSubHeader: {
    textTransform: "uppercase",
    color: "#212529",
    fontSize: 14,
    padding: "20px 0px 10px 0px",
    fontWeight: "600 !important"
  },

  // balance: { color: "#344767", paddingTop: 15, fontSize: "1.15rem", fontWeight: 600 },

  // userWelcome: {
  //   display: "flex",
  //   alignItems: "center",
  //   marginLeft: 10,
  //   fontWeight: 600,
  //   textTransform: "uppercase",
  //   color: "#344767"
  // },

  // cardHeader: {
  //   fontWeight: 600,
  //   textTransform: "uppercase",
  //   color: "#344767",
  //   marginBottom: 20
  // },

  listItemIcon: {
    '& .MuiSvgIcon-root': {
      width: "1.5em",
      display: "flex",
      alignItems: "center",
      height: "1.5em",
      fill: "#303778",
      background: "#92278F",
      fill: "#fff",
      borderRadius: "0.5rem",
      padding: 5,
      boxShadow: "0 0.25rem 0.375rem -0.0625rem rgb(20 20 20 / 12%), 0 0.125rem 0.25rem -0.0625rem rgb(20 20 20 / 7%) !important"
    }
  },

  // '& span.MuiTypography-root': {
  //   color: "#303778",
  //   fontWeight: 400,
  //   fontFamily: 'GT Walsheim Pro'
  // }
  //},

  listItem: {
    paddingRight: 0,
    '&:hover': {
      paddingRight: 0,
      borderRadius: "0.75rem",

      '& div.listItemText': {
        '& span.MuiTypography-root': {
          fontWeight: 600,
        }
      },

      '& span.MuiTypography-root': {
        color: "#92278F",
        fontWeight: 400,
        fontFamily: 'Noto Sans '
      }
    },
  },

  listItem: {
    paddingRight: 0,
    '&:hover': {
      paddingRight: 0,
      borderRadius: "0.75rem",
      background: "#FFF8FF",

      '& div.listItemText': {
        '& span.MuiTypography-root': {
          fontWeight: 600,
        }
      },

      '& listItemIcon': {
        '& svg.MuiSvgIcon-root': {
          background: "#303778",
          fill: "#fff",
          borderRadius: "0.5rem",
          padding: 5,
        }
      }
    },
  },

  menuContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    },
    '& .MuiPaper-root': {
      borderRight: "none",
      // background:"#f8f9fa !important"
    }
  },

  rightContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    }
  },

  logo: {
    margin: "20px !important",
    margin: "0px !important"
  },

  logoContainer: {
    background: "#fff", margin: 15, display: "flex",
    alignItems: "center",
    padding: "0px 10px"
  },



  txtWelcome: {
    fontWeight: 600,
    fontSize: 16,
    margin: 15,
    textTransform: "uppercase",
    fontFamily: "Noto Sans ",
    color: "#000000"
  },
  errorStyle: {
    fontSize: 12,
    color: Color.ERROR,
    //letterSpacing: 1,
    height: 14,
    marginTop: 5
  },
})

const mapStateToProps = (state) => ({
  accNo: state.dashboard.accNo,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { accNoAdd },
    dispatch
  );
};

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(FundTransfer))
);
